import { Component, Input } from '@angular/core';
import {
  AgrupamentoConfigForm,
  AgrupamentoFiltro,
  AgrupamentoOrdenacao,
  AgrupamentoTratamento,
  TipoOperacao,
  TipoOperador
} from '../../../types/smartinteg';
import {
  DIRECOES,
  OPERACOES,
  OPERADORES,
  TRANSFORMACOES_CHAVE,
  aceitaCamposAdicionais,
  aceitaOrdenacao,
  novaVariavel,
  novoFiltro,
  novoTratamento,
  operadorSemValor,
  semCampoFonte,
  variaveisNaoDeclaradas
} from './agrupamento-config.util';

/**
 * Editor de Recurso.configuracoes.agrupamento (chaves, ordenação, tratamentos e opções).
 * Edita o modelo recebido no lugar; quem salva usa montarAgrupamento/validarAgrupamento do util.
 */
@Component({
  selector: 'app-agrupamento-config',
  templateUrl: './agrupamento-config.component.html',
  styleUrls: ['./agrupamento-config.component.css']
})
export class AgrupamentoConfigComponent {

  @Input() model!: AgrupamentoConfigForm;
  @Input() aba = 'chaves';

  readonly transformacoes = TRANSFORMACOES_CHAVE;
  readonly operacoes = OPERACOES;
  readonly operadores = OPERADORES;
  readonly direcoes = DIRECOES;

  semCampoFonte = semCampoFonte;
  aceitaCamposAdicionais = aceitaCamposAdicionais;
  aceitaOrdenacao = aceitaOrdenacao;
  operadorSemValor = operadorSemValor;

  // ---- chaves e ordenação global ----
  adicionarChave(): void { this.model.chaves.push({ campo: '', transformacao: 'TEXTO' }); }
  removerChave(i: number): void { this.model.chaves.splice(i, 1); }

  // ---- listas genéricas (filtros, ordenação e campos adicionais de cada tratamento) ----
  adicionarOrdenacao(lista: AgrupamentoOrdenacao[]): void { lista.push({ campo: '', direcao: 'ASC' }); }
  adicionarFiltro(lista: AgrupamentoFiltro[]): void { lista.push(novoFiltro()); }
  remover(lista: unknown[], i: number): void { lista.splice(i, 1); }

  // ---- tratamentos ----
  adicionarTratamento(): void { this.model.tratamentos.push(novoTratamento()); }
  removerTratamento(i: number): void { this.model.tratamentos.splice(i, 1); }

  moverTratamento(i: number, delta: number): void {
    const j = i + delta;
    if (j < 0 || j >= this.model.tratamentos.length) return;
    const [t] = this.model.tratamentos.splice(i, 1);
    this.model.tratamentos.splice(j, 0, t);
  }

  adicionarCampoAdicional(t: AgrupamentoTratamento): void { t.camposAdicionais.push({ nomeCampo: '', nomeDestino: '' }); }
  adicionarVariavel(t: AgrupamentoTratamento): void { t.variaveis.push(novaVariavel()); }

  naoDeclaradas(t: AgrupamentoTratamento): string[] {
    return t.tipoOperacao === 'FORMULA' ? variaveisNaoDeclaradas(t.formula ?? '', t.variaveis) : [];
  }

  destinoEfetivo(t: AgrupamentoTratamento): string {
    return (t.nomeDestino ?? '').trim() || (semCampoFonte(t.tipoOperacao) ? '' : (t.nomeCampo ?? '').trim());
  }

  rotuloOperacao(op: TipoOperacao): string { return this.operacoes.find(o => o.value === op)?.label ?? op; }

  trackIndex(i: number): number { return i; }
}
